import { EventBus } from '../event-bus';
import { BridgeDataChanged } from '../events/bridge-data-changed';
import { DatabaseContentIdChanged } from '../events/database-content-id-changed';
import { EventListener } from '../types';

export class MaybeDispatchContentIdChanged implements EventListener<BridgeDataChanged> {
  constructor(private readonly eventBus: EventBus) {}

  handle(event: BridgeDataChanged): void {
    if (event.payload.newContentId !== event.payload.oldContentId) {
      this.eventBus.dispatch(new DatabaseContentIdChanged());
    }
  }
}
